import React, { useEffect } from 'react';
import { useOutletContext, useNavigate, useOutlet } from 'react-router-dom';
import NavMenu from '../../../components/NavMenu'
import StoreCreator from '../../../components/StoreCreator'
import EmailVerification from '../../../components/EmailVerification';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

export default function App() {
    const navigate = useNavigate();
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu] = useOutletContext()
    const outlet = useOutlet()

    useEffect(() => {
        if (outlet === null) {
            navigate("/admin/app")
        }
    }, [outlet, navigate])

    useEffect(() => {
        if (userAuth === false) {
            navigate("/admin/login")
        }
    }, [userAuth, navigate])

    if (userAuth === undefined
        || userData === undefined
        || (userData && userMenu === undefined)) {
        return <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>

    } else {
        // Esta logueado y tiene un menu cargado
        // DESCOMENTAR EL CODIGO PARA ACTIVAR EL EMAIL VERIFICATION
        //if (userAuth.emailVerified) {
        // No tiene un menu guardado
        if (userData === null) {
            return <StoreCreator userAuth={userAuth} updateUserData={updateUserData} />

        } else {
            return (
                <>
                    <NavMenu
                        userAuth={userAuth}
                        userData={userData}
                        userMenu={userMenu}
                        updateUserData={updateUserData}
                        updateUserMenu={updateUserMenu}
                    />
                </>
            )
        }
        // } else {
        //     return <EmailVerification userAuth={userAuth} />
        // }
    }
}
